import { RadioList, RadioListItem, useTheme } from '@salecycle/ui-component-library';
import { T } from '@salecycle/experimental/Typography/Typography';
import { useTranslation } from 'react-i18next';
import { useSetSortOption } from 'sections/bulk-retargeting-campaigns/CampaignEditor/state/actions/useSetSortOption';
import { useCampaignEditorContext } from 'sections/bulk-retargeting-campaigns/CampaignEditor/state/hooks/useCampaignEditorContext';
import { useFeatureFlags } from 'core/app/AppContext';

export const BulkSortByFeature = () => {
  const { state } = useCampaignEditorContext();
  const { flagEnabled } = useFeatureFlags();
  const theme = useTheme();
  const { t } = useTranslation('campaigns');
  const setSortOption = useSetSortOption();

  if (!flagEnabled('ld-bulk-targeting')) {
    return null;
  }

  return (
    <div style={{ display: 'flex', gap: theme.designToken.spacing3, flexDirection: 'column' }}>
      <T>Select your type of prioritisation below</T>
      <RadioList>
        <div style={{ display: 'flex', gap: theme.designToken.spacing2 }}>
          <RadioListItem
            id="recency"
            heading={t('bulkRetargetingCampaigns.editor.byRecency')}
            description={t('bulkRetargetingCampaigns.editor.byRecencyDescription')}
            onClick={state.campaign.bulkSortByFeature && (() => setSortOption(false))}
            disabled={state.readOnly}
            selected={!state.campaign.bulkSortByFeature}
          />

          <RadioListItem
            id="manual"
            heading={t('bulkRetargetingCampaigns.editor.manual')}
            description={t('bulkRetargetingCampaigns.editor.manualDescription')}
            onClick={!state.campaign.bulkSortByFeature && (() => setSortOption(true))}
            disabled={state.readOnly}
            selected={state.campaign.bulkSortByFeature}
          />
        </div>
      </RadioList>
    </div>
  );
};
